var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0791 0.26125C12.6381 0.405 13.0788 0.82875 13.2283 1.36625C13.5 2.34125 13.5 5 13.5 5C13.5 5 13.5 7.65875 13.2283 8.63375C13.0788 9.17125 12.6387 9.595 12.0791 9.73875C11.0651 10 7 10 7 10C7 10 2.9349 10 1.9209 9.73875C1.3619 9.595 0.9212 9.17125 0.7717 8.63375C0.5 7.65875 0.5 5 0.5 5C0.5 5 0.5 2.34125 0.7717 1.36625C0.9212 0.82875 1.3619 0.405 1.9209 0.26125C2.9349 0 7 0 7 0C7 0 11.0651 0 12.0791 0.26125ZM9.59992 4.99898L5.69992 2.83398V7.16398L9.59992 4.99898Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-youtube.d6e877fb.svg";
export { ForwardRef as ReactComponent };